export default "/_next/static/images/f6f5818bdc0d0b7aad3ca936a60c9cd9.jpg";